import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class BaseMenuPopupContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addActions();
        this.hide();
    }

    init() {
        this.infoButton = this.getChildByName('infoButton');
        this.settingsButton = this.getChildByName('settingsButton');
        this.rulesButton = this.getChildByName('rulesButton');

        this.infoButton.enabled = true;
        this.settingsButton.enabled = true;
        this.rulesButton.enabled = true;

        this.infoButton.checked = true;
    }

    addActions() {
        this.infoButton.actions = {
            checked: {
                callback: this.onButtonClick, context: this, params: 1
            }
        };
        this.settingsButton.actions = {
            checked: {
                callback: this.onButtonClick, context: this, params: 2
            }
        };
        this.rulesButton.actions = {
            checked: {
                callback: this.onButtonClick, context: this, params: 3
            }
        };
    }

    onButtonClick(data) {
        this.infoButton.enabled = true;
        this.settingsButton.enabled = true;
        this.rulesButton.enabled = true;

        switch (data) {
            case 1:
                this.infoButton.checked = true;
                this.infoButton.enabled = false;
                this.settingsButton.checked = false;
                this.rulesButton.checked = false;
                break;
            case 2:
                this.infoButton.checked = false;
                this.settingsButton.checked = true;
                this.settingsButton.enabled = false;
                this.rulesButton.checked = false;
                break;
            case 3:
                this.infoButton.checked = false;
                this.settingsButton.checked = false;
                this.rulesButton.checked = true;
                this.rulesButton.enabled = false;
                break;
        }
        GlobalDispatcher.dispatch('paytable:goToPage', data);
    }

    switch() {
        if(this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        this.visible = true;
        //this.onButtonClick(1);
    }

    hide() {
        this.visible = false;
    }
}